import { gql } from '@apollo/client'

import { DEFECT_ATTRIBUTES } from '../defects/graphQL'

export const GET_PLATFORM_USAGE_REPORT = gql`
  query getPlatformUsage_UI($filter: PlatformUsageReportFilterInput) {
    getPlatformUsage(filter: $filter) {
      inductions
      workers {
        numberOfUsers
        numberOfWorkers
        numberOfManuallyCreatedWorkers
        vaccineStatus {
          firstVaccine
          secondVaccine
          thirdVaccine
          exemption
          noVaccine
        }
      }
      numberOfVisitors
      signOns {
        total
        manual
        visitor
      }
      subcontractors
      toolboxes
      SWMS {
        total
        reviewed
        pendingReview
        requestedChanges
      }
      insurances
      preStarts
      checklists
      checklistReport {
        started
        completed
        topCategories {
          name
          completed
        }
      }
      actions
      communications
      defects {
        total
        inProgress
        resolved
        overdue
        waitingReview
        incompleteWorks
        builderDefects
        clientDefects
      }
      siteDiaries {
        total
        projectHours
        numberOfWorkers
        numberOfSubcontractors
        inclementWeatherHours
      }
      siteDiariesCount
    }
  }
`

export const GET_PLATFORM_AGGREGATION_REPORT = gql`
  query getPlatformAggregation_UI($filter: PlatformUsagAggregationFilterInput) {
    getPlatformAggregation(filter: $filter) {
      newAudits
      totalAudits

      newUsers
      totalUsers

      newProjects
      totalProjects

      newBuilders
      totalBuilders

      newWorkers
      totalWorkers
      totalWorkerActions

      newAdminUsers
      totalAdminUsers
      totalAdminUserActions

      newSubcontractors
      totalSubcontractors
      totalSubcontractorActions

      newDefects
      totalDefects

      historicalPlatformUsage {
        newAudits
        adminUsersToDate
        month
      }
    }
  }
`

export const GET_PLATFORM_ENGAGEMENT_REPORT = gql`
  query getPlatformEngagement_UI($filter: PlatformEngagementFilterInput) {
    getPlatformEngagement(filter: $filter) {
      builders {
        resourceName
        resourceId
        actions
        date
      }

      totalAuditsPerBuilder {
        resourceName
        resourceId
        actions
      }

      totalAuditsPerFeature {
        resourceName
        resourceId
        actions
      }

      features {
        resourceName
        actions
        date
      }

      metadata {
        builders {
          id
          isDemo
          company {
            name
          }
        }
        projects {
          id
        }
        adminUsers {
          id
        }
      }
      builderEngagement {
        latestProject {
          id
          name
          createdAt
        }
        latestSignOn {
          id
          createdAt
          project {
            name
          }
        }
        latestAudit {
          id
          createdAt
          action
          actionBy
          resource
        }
        latestAdminUserAudit {
          id
          createdAt
          action
          actionBy
          resource
        }
      }
    }
  }
`
export const GET_SUBCONTRACTOR_REPORT = gql`
  query getSubcontractorReport_UI($filter: SubcontractorReportFilterInput) {
    getSubcontractorReport(filter: $filter) {
      subcontractors {
        id
        name
        numberOfWorkers
        projectHours
        projectHoursByDate {
          date
          projectHours
        }
        workers {
          id
          name
          projectHours
        }
      }
    }
  }
`

export const GET_DEFECT_REPORT = gql`
  query getDefectReport_UI($filter: DefectReportFilterInput) {
    getDefectReport(filter: $filter) {
      statistics {
        total
        inProgress
        resolved
        overdue
        waitingReview
        incompleteWorks
        builderDefects
        clientDefects
      }
      overdue {
        ...defectAttributes
      }
      waitingReview {
        ...defectAttributes
      }
    }
  }
  ${DEFECT_ATTRIBUTES}
`

export const GET_PROJECT_HOURS_BUDGET_REPORT = gql`
  query getProjectHoursBudgetReport_UI(
    $filter: ProjectHoursBudgetReportFilterInput!
  ) {
    getProjectHoursBudgetReport(filter: $filter) {
      lastLoggedCompletionPercentage
      completionLastLoggedAt
      projectHoursByDate {
        date
        projectHours
      }
      projectCompletionByDate {
        date
        completionPercentage
      }
      subcontractors {
        id
        name
        numberOfWorkers
        projectHours
        projectHoursByDate {
          date
          projectHours
        }
        workers {
          id
          name
          projectHours
        }
      }
      status
      totalHours
    }
  }
`

export const GET_ALL_PROJECTS_BUDGET_REPORT = gql`
  query getAllProjectHoursBudgetReports_UI(
    $filter: AllProjectHoursBudgetReportFilterInput
  ) {
    getAllProjectHoursBudgetReports(filter: $filter) {
      projects {
        projectId
        project {
          name
        }
        budget
        projectHours
        percentageHoursUsed
        status
      }
    }
  }
`

export const GET_PROJECT_HOURS_BUDGET_REPORT_FOR_SITE_DIARY = gql`
  query getProjectHoursBudgetReportForSiteDiary_UI($siteDiaryId: String!) {
    getProjectHoursBudgetReportForSiteDiary(siteDiaryId: $siteDiaryId) {
      lastLoggedCompletionPercentage
      subcontractors {
        id
        name
        numberOfWorkers
        projectHours
      }
      status
      totalHours
    }
  }
`
